// extracted by mini-css-extract-plugin
export default {"Columns":"styles_Columns__OvAdc"};